export const text = {
    pageTitle: "STT From File",
    errorMsg: "مشکلی پیش آمده، لطفا دوباره تلاش کنید.",
    dragMsg: "Drag and Drop Files Here or Click to Select",
    uploadingMsg: "Uploading File...",
    onlyAudioMsg: "Only Audio Files Are Accepted.",
    textPlaceholder: "Your speech will be shown here!",
}
